import React from 'react'

const FeatureItem = ({ icon: Icon, title, description }) => (
    <div className="flex items-center space-x-3">
        <div className="w-10 h-10 bg-white bg-opacity-20 rounded-lg flex items-center justify-center">
            <Icon className="w-5 h-5" />
        </div>
        <div>
            <h3 className="font-semibold">{title}</h3>
            <p className="text-sm text-blue-200">{description}</p>
        </div>
    </div>
)

export default FeatureItem